import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import * as extractsActions from '../store/actions';
import * as pillarActions from '../../pillar/dashboard/store/actions';
import { ModelResponse } from '../../core/services/ModelResponse';
import { ExtractsService } from "./ExtractsService";
import { QueryResponse } from '../../core/services/QueryResponse';
import { ExtractModel } from "../models/ExtractModel";
import { ExtractListModel } from "../models/ExtractListModel";
import { CalOmsExtractWorkspaceModel } from "../models/CalOmsExtractWorkspaceModel";
import { ExtractPageViewModel } from "../models/ExtractPageViewModel";
import { ActionError } from '../../pillar/common/actions/ActionError';
import { ResponseMessage } from '../../core/services/ResponseMessage';
import { ResponseMessageType } from '../../core/services/ResponseMessageType';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionBase } from '../../core/store/action/ActionBase';
import { ModuleConfiguration } from '../extracts.module.config';

@Injectable()
export class ExtractsServiceEffects {
  @Effect()
  getExtractCategoryList$: Observable<Action> = this.actions$.ofType(extractsActions.GET_EXTRACT_CATEGORY_QUERY)
      .switchMap((a: extractsActions.GetExtractCategoryQueryAction) => this.extractsService.getExtractCategoryList ( a.payload.page, a.payload.pageSize, a.payload.sort, a.payload.sortDirection, a.payload.searchTerm )
        .catch((error: HttpErrorResponse) => {
          var response = new QueryResponse<ExtractModel>();
          response.hasError = true;
          var responseMessage = new ResponseMessage();
          responseMessage.type = ResponseMessageType.Error;
          responseMessage.value = error.message;
          response.messages = [responseMessage];
          return Observable.of(response);
        })
        .map((response: QueryResponse<ExtractModel>) => {
          if (response.hasError) {
            return new ActionError(a, response.messages.map(m => m.value));
          }
          return new extractsActions.GetExtractCategoryQuerySuccessAction ( { items: response.items } );
      }));

  @Effect()
  getExtractList$: Observable<Action> = this.actions$.ofType(pillarActions.getQueryListType<ExtractListModel>(ModuleConfiguration.moduleName, ExtractListModel))
      .map((a: extractsActions.GetExtractListAction) => a.payload)
      .switchMap((payload: ExtractPageViewModel) => this.extractsService.getExtractList(payload.page, payload.pageSize, payload.sort, payload.sortDirection, payload.searchTerm, payload.model)
        .map((response: QueryResponse<ExtractListModel>) => {
        if (response.hasError) {
          return new pillarActions.TileErrorsAction(ModuleConfiguration.moduleName, ExtractListModel, { errors: response.messages.map(m => m.value) });
        }
        return new pillarActions.QuerySuccessAction(ModuleConfiguration.moduleName, ExtractListModel, { items: response.items, totalCount: response.totalCount });
      }));

  @Effect()
  finalizeExtract$: Observable<Action> = this.actions$.ofType(extractsActions.FINALIZE_EXTRACT)
      .switchMap((action: extractsActions.FinalizeExtractAction) => this.extractsService.finalizeExtract(action.payload.extractKey, action.payload.model)
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<boolean>(error)))
      .map((response: ModelResponse<boolean>) => {
        if (response.hasError) {
          return new ActionError(action, response.messages.map(m => m.value));
        }
        return new extractsActions.FinalizeExtractSuccessAction();
      }));

  @Effect()
  deletedExtract$: Observable<Action> = this.actions$.ofType(extractsActions.DELETE_EXTRACT)
    .switchMap((action: extractsActions.DeleteExtractAction) => this.extractsService.deleteExtract(action.payload.extractKey, action.payload.model)
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<boolean>(error)))
      .map((response: ModelResponse<boolean>) => {
        if (response.hasError) {
          return new ActionError(action, response.messages.map(m => m.value));
        }
        return new extractsActions.DeleteExtractSuccessAction();
      }));

  @Effect()
  generateExtract$: Observable<Action> = this.actions$.ofType(extractsActions.GENERATE_EXTRACT)
    .switchMap((action: extractsActions.GenerateExtractAction) => this.extractsService.generateExtract(action.payload.model)
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<string>(error)))
      .map((response: ModelResponse<string>) => {
        if (response.hasError) {
          return new ActionError(action, response.messages.map(m => m.value));
        }
        return new extractsActions.GenerateExtractSuccessAction({ extractKey: response.model });
      }));

  @Effect()
  generateChildExtracts$: Observable<Action> = this.actions$.ofType(extractsActions.GENERATE_CHILD_EXTRACTS)
      .switchMap((action: extractsActions.GenerateChildExtractsAction) => this.extractsService.generateChildExtracts(action.payload.extractKey, action.payload.model)
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<number>(error)))
      .map((response: ModelResponse<number>) => {
        if (response.hasError) {
          return new ActionError(action, response.messages.map(m => m.value));
        }
        return new extractsActions.GenerateChildExtractsSuccessAction({ fileGenerated: response.model });
      }));

  @Effect()
  getExtractWorkspaceList$: Observable<Action> = this.actions$.ofType(pillarActions.getQueryListType<CalOmsExtractWorkspaceModel>(ModuleConfiguration.moduleName, CalOmsExtractWorkspaceModel))
      .switchMap((a: extractsActions.GetSelectedExtractAction) => this.extractsService.getExtractWorkspaceList(a.payload.key, a.payload.page, a.payload.pageSize, a.payload.sort, a.payload.sortDirection, a.payload.searchTerm, a.payload.extractType, a.payload.model, a.payload.filterModel )
        .map((response: QueryResponse<CalOmsExtractWorkspaceModel>) => {
        if (response.hasError) {
          return new pillarActions.TileErrorsAction(ModuleConfiguration.moduleName, CalOmsExtractWorkspaceModel, { errors: response.messages.map(m => m.value) });
        }
          return new extractsActions.GetSelectedExtractSuccessAction({ items: response.items });
      }));

  @Effect()
  saveExtract$: Observable<Action> = this.actions$.ofType(extractsActions.SAVE_EXTRACT)
    .switchMap((action: extractsActions.SaveExtractAction) => this.extractsService.saveExtract( action.payload.model )
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<boolean>(error)))
      .map((response: ModelResponse<boolean>) => {
        if (response.hasError) {
          return new ActionError(action, response.messages.map(m => m.value));
        }
        return new extractsActions.SaveExtractSuccessAction ();
      }));

  constructor(
    private extractsService: ExtractsService,
    private actions$: Actions
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/services/ExtractsService.effects.ts